/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as QcRouteImport } from './routes/qc'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PmRouteImport } from './routes/pm'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DevRouteImport } from './routes/dev'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as BlockedRouteImport } from './routes/blocked'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminReportRouteImport } from './routes/admin_.report'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const QcRoute = QcRouteImport.update({
  id: '/qc',
  path: '/qc',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PmRoute = PmRouteImport.update({
  id: '/pm',
  path: '/pm',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DevRoute = DevRouteImport.update({
  id: '/dev',
  path: '/dev',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const BlockedRoute = BlockedRouteImport.update({
  id: '/blocked',
  path: '/blocked',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminReportRoute = AdminReportRouteImport.update({
  id: '/admin_/report',
  path: '/admin/report',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/blocked': typeof BlockedRoute
  '/dashboard': typeof DashboardRoute
  '/dev': typeof DevRoute
  '/login': typeof LoginRoute
  '/pm': typeof PmRoute
  '/profile': typeof ProfileRoute
  '/qc': typeof QcRoute
  '/settings': typeof SettingsRoute
  '/admin/report': typeof AdminReportRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/blocked': typeof BlockedRoute
  '/dashboard': typeof DashboardRoute
  '/dev': typeof DevRoute
  '/login': typeof LoginRoute
  '/pm': typeof PmRoute
  '/profile': typeof ProfileRoute
  '/qc': typeof QcRoute
  '/settings': typeof SettingsRoute
  '/admin/report': typeof AdminReportRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/blocked': typeof BlockedRoute
  '/dashboard': typeof DashboardRoute
  '/dev': typeof DevRoute
  '/login': typeof LoginRoute
  '/pm': typeof PmRoute
  '/profile': typeof ProfileRoute
  '/qc': typeof QcRoute
  '/settings': typeof SettingsRoute
  '/admin_/report': typeof AdminReportRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/blocked'
    | '/dashboard'
    | '/dev'
    | '/login'
    | '/pm'
    | '/profile'
    | '/qc'
    | '/settings'
    | '/admin/report'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/blocked'
    | '/dashboard'
    | '/dev'
    | '/login'
    | '/pm'
    | '/profile'
    | '/qc'
    | '/settings'
    | '/admin/report'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/blocked'
    | '/dashboard'
    | '/dev'
    | '/login'
    | '/pm'
    | '/profile'
    | '/qc'
    | '/settings'
    | '/admin_/report'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  BlockedRoute: typeof BlockedRoute
  DashboardRoute: typeof DashboardRoute
  DevRoute: typeof DevRoute
  LoginRoute: typeof LoginRoute
  PmRoute: typeof PmRoute
  ProfileRoute: typeof ProfileRoute
  QcRoute: typeof QcRoute
  SettingsRoute: typeof SettingsRoute
  AdminReportRoute: typeof AdminReportRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/qc': {
      id: '/qc'
      path: '/qc'
      fullPath: '/qc'
      preLoaderRoute: typeof QcRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pm': {
      id: '/pm'
      path: '/pm'
      fullPath: '/pm'
      preLoaderRoute: typeof PmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev': {
      id: '/dev'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof DevRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blocked': {
      id: '/blocked'
      path: '/blocked'
      fullPath: '/blocked'
      preLoaderRoute: typeof BlockedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin_/report': {
      id: '/admin_/report'
      path: '/admin/report'
      fullPath: '/admin/report'
      preLoaderRoute: typeof AdminReportRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  BlockedRoute: BlockedRoute,
  DashboardRoute: DashboardRoute,
  DevRoute: DevRoute,
  LoginRoute: LoginRoute,
  PmRoute: PmRoute,
  ProfileRoute: ProfileRoute,
  QcRoute: QcRoute,
  SettingsRoute: SettingsRoute,
  AdminReportRoute: AdminReportRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
